import { IsBoolean, IsNumber, IsOptional, Min, ValidateIf } from 'class-validator';

export class ExportCropBoxDto {
	@IsOptional()
	@IsBoolean()
	enabled?: boolean = false;

	@ValidateIf(o => o.enabled === true)
	@IsNumber()
	@Min(0)
	x: number;

	@ValidateIf(o => o.enabled === true)
	@IsNumber()
	@Min(0)
	y: number;

	@ValidateIf(o => o.enabled === true)
	@IsNumber()
	@Min(1)
	width: number;

	@ValidateIf(o => o.enabled === true)
	@IsNumber()
	@Min(1)
	height: number;
}